/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import service from "./services";
import jwt from "jsonwebtoken";
//import ability from './services/ability';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      redirect: "",
      beforeEnter: (to, from, next) => isAuth(to, from, next),
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/dashBoard",
          name: "Dashboard",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/Home2.vue"),
          meta: {
            checkPermission: false,
          },
        },

        // =============================================================================
        // MENU ADMINISTRADOR (CADASTRO)
        // =============================================================================

        {
          path: "/carteiras",
          name: "Carteiras",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/carteiras/carteiras.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Carteiras de Cobrança",
            rule: "editor",
          },
        },
        {
          path: "/carteiras/:idCarteira/recebedores",
          name: "Carteiras-Recebedores",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/carteiras/ListRecebedores.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Carteira de Cobrança",
                url: "/carteiras",
              },
              {
                title: "Recebedores",
                active: true,
              },
            ],
            pageTitle: "Recebedores",
            rule: "editor",
          },
        },
        {
          path: "/usuarios",
          name: "Usuarios",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/usuarios/usuarios.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Usuários",
            rule: "editor",
          },
        },
        {
          path: "/afiliados",
          name: "Afiliados",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/afiliados/afiliados.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Afiliados",
            rule: "editor",
          },
        },
        {
          path: "/encomendas",
          name: "Encomendas",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("@/views/pages/painelEncomendas.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Encomendas",
            rule: "editor",
          },
        },
        {
          path: "/detalheEncomenda/:idEncomenda",
          name: "detalheEncomenda",
          beforeEnter: function (to, from, next) {
            isAuth(to, from, next);
            maintenance(next);
          },
          component: () =>
            import("./views/menu/encomendas/detalheEncomenda.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Detalhe da Encomenda",
                url: "/detalheEncomenda",
              },
              {
                title: "Editar",
                active: true,
              },
            ],
            pageTitle: "Editar",
            rule: "editor",
            checkPermission: false,
          },
        },

        {
          path: "/tagsEncomendas",
          name: "tagsEncomendas",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/cadastros/tags/tags.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Tags de Encomenda",
            rule: "editor",
          },
        },
        {
          path: "/tiposCaixas",
          name: "Tipos",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/cadastros/tipos/tipos.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Tipos de Caixas",
            rule: "editor",
          },
        },
        {
          path: "/tabelasFrete",
          name: "tabelasFrete",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/tabelaFrete/tabelaFrete.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Tabelas de Frete",
            rule: "editor",
          },
        },
        {
          path: "/cupoms",
          name: "cupoms",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/cadastros/cupoms/Cupoms.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Cupoms",
            rule: "editor",
          },
        },

        {
          path: "/marcasPersonalidades",
          name: "MarcasPersonalidades",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/marcasPersonalidade/marcas.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Marcas e Personalidades",
            rule: "editor",
          },
        },

        {
          path: "/produtos",
          name: "produtos",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/produtos/produtos.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Produtos",
            rule: "editor",
          },
        },

        {
          path: "/shopping",
          name: "shopping",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/shopping/shopping.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Shopping",
            rule: "editor",
          },
        },

        {
          path: "/listCaixaItens/:idCaixa",
          name: "listCaixaItens",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/cadastros/caixasItens/caixasItens.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Itens",
                active: true,
              },
            ],
            pageTitle: "Itens",
            rule: "editor",
          },
        },
        {
          path: "/DetalheUsuario/:idUsuario",
          name: "DetalheUsuario",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/usuarios/detalheUsuario.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Itens",
                active: true,
              },
            ],
            pageTitle: "Detalhe Usuario",
            rule: "editor",
          },
        },
        {
          path: "/caixas",
          name: "Caixas",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/cadastros/caixas/caixas.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Cadastro",
                active: true,
              },
            ],
            pageTitle: "Caixas",
            rule: "editor",
          },
        },
        {
          path: "/banners",
          name: "Banners",
          beforeEnter: (to, from, next) => isAuth(to, from, next),

          component: () =>
            import("./views/menu/configuracoes/banners/banners.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Configurações",
                active: true,
              },
            ],
            pageTitle: "Banners",
            rule: "editor",
          },
        },
        {
          path: "/empresas",
          name: "empresas",
          beforeEnter: (to, from, next) => isAuth(to, from, next),

          component: () =>
            import("./views/menu/configuracoes/empresas/empresas.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Empresa",
                active: true,
              },
            ],
            pageTitle: "Empresa",
            rule: "editor",
          },
        },
        {
          path: "/textos",
          name: "textos",
          beforeEnter: (to, from, next) => isAuth(to, from, next),

          component: () =>
            import("./views/menu/configuracoes/textos/textos.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Configurações",
                active: true,
              },
            ],
            pageTitle: "Textos",
            rule: "editor",
          },
        },
        {
          path: "/faq",
          name: "faq",
          beforeEnter: (to, from, next) => isAuth(to, from, next),

          component: () => import("./views/menu/configuracoes/faq/faq.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Configurações",
                active: true,
              },
            ],
            pageTitle: "Faq",
            rule: "editor",
          },
        },
        {
          path: "/PainelFinanceiro",
          name: "Painel Financeiro",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/financeiro/PainelFinanceiro.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Painel Financeiro",
                active: true,
              },
            ],
            pageTitle: "Painel Financeiro",
            rule: "editor",
          },
        },
        {
          path: "/Bling",
          name: "Integração Bling",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () => import("./views/menu/bling/PainelBling.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Integração Bling",
                active: true,
              },
            ],
            pageTitle: "Integração Bling",
            rule: "editor",
          },
        },
        {
          path: "/mensageria",
          name: "mensageria",
          beforeEnter: (to, from, next) => isAuth(to, from, next),
          component: () =>
            import("./views/menu/configuracoes/mensageria/mensageria.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Configurações",
                active: true,
              },
            ],
            pageTitle: "Mensageria",
            rule: "editor",
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/Login",
          name: "pageLogin",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/painelEncomendas",
          name: "painelEncomendas",
          component: () => import("@/views/pages/painelEncomendas.vue"),
        },
        {
          path: "/boleto/:idRegistroFinanceiro/:nossoNumero",
          name: "boleto",
          component: () => import("@/views/pages/Boleto.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

function isAuth(to, from, next) {
  const token = localStorage.getItem("user-token");

  if (!token) {
    return next("/Login");
  }

  const decoded = jwt.decode(token);

  service
    .validaToken(token, "Login", "ValidateToken")
    .then((res) => {
      if (
        res.data.result === false ||
        ![1, 3, 4].includes(Number(decoded.idPerfil))
      ) {
        return next("/Login");
      }

      const resource = to.name ? to.name.toLowerCase() : "";
      const rules = decoded.rules || {};
      const action = "view";

      if (rules.All && rules.All.includes("*")) {
        return next();
      }

      if (rules[resource] && rules[resource].includes(action)) {
        return next();
      }

      for (const key of Object.keys(rules)) {
        if (key.endsWith("/*")) {
          const prefix = key.slice(0, -2).toLowerCase();
          if (resource.startsWith(prefix) && rules[key].includes(action)) {
            return next();
          }
        }
      }

      console.warn(`Acesso negado para recurso [${resource}] com ação [${action}]`);
      return next("/Login");
    })
    .catch((e) => {
      console.error("Erro na validação de token:", e);
      next("/Login");
    });
}

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
// function isAuth(to, from, next) {
//   const token = localStorage.getItem("user-token");

//   if (!token) {
//     return next("/Login");
//   }

//   const decoded = jwt.decode(token);

//   service
//     .validaToken(token, "Login", "ValidateToken")
//     .then((res) => {
//       if (res.data.result === false) {
//         return next("/Login");
//       }

//       const rules = decoded.rules || {};

//       // Se tem regra ALL com '*', libera tudo
//       if (rules.All && rules.All.includes("*")) {
//         return next();
//       }

//       const requiredRule = to.meta.rule; // ex: 'view', 'editor', etc

//       if (!requiredRule) {
//         return next();
//       }

//       const hasPermission = Object.values(rules).some((perms) =>
//         perms.includes(requiredRule)
//       );

//       if (!hasPermission) {
//         return next("/sem-permissao");
//       }

//       next();
//     })
//     .catch((e) => {
//       console.error(e);
//       next("/Login");
//     });
// }

/*
function validatePermission(to, next) {
  if (to.meta.checkPermission != undefined) {
    if (!to.meta.checkPermission) {
      return next();
    }
  }

  const permission = ability.getPermission();

  if (permission.can("Leitura", to.name)) {
    return next();
  }

  next(`/401`);
}*/

export default router;
